<script setup lang="ts">
defineProps<{
  googleUrl: string;
  facebookUrl: string;
}>();

// Assets served from public/. Bound dynamically (rather than as literal
// `src=` attributes) so Vue's template compiler doesn't treat the paths as
// build-time asset imports — Vite's fs.allow blocks that virtual resolution
// under Vitest, which would break the page-level component test mount.
const googleLogoSrc = '/img/sso/google.svg';
const facebookLogoSrc = '/img/sso/facebook.svg';
</script>

<template>
  <v-btn :href="googleUrl" variant="outlined" block size="large" class="mb-2">
    <img :src="googleLogoSrc" alt="" width="20" height="20" class="mr-2" />
    Continue with Google
  </v-btn>
  <v-btn :href="facebookUrl" variant="outlined" block size="large" class="mb-4">
    <img :src="facebookLogoSrc" alt="" width="20" height="20" class="mr-2" />
    Continue with Facebook
  </v-btn>
</template>
